<template>
  <card style="min-height: 510px;background-color: initial;box-shadow: none;">
    <template slot="header">
      <div v-for="(rfmTracking, i) in rfmTrackingMessagesSubList" :key="i">
        <el-col :xs="24" :sm="18" :md="12" :lg="12" :xl="12">
          <RFMTrackingMessagesSection :rfmTracking="rfmTracking" />
        </el-col>
      </div>
      <div style="position: absolute; bottom: 0; width: 97%; height: 0%"
        >
        <PaginationFunctional
          sublistName="rfmTrackingMessagesSubList"
          :fullList="rfmTrackingMessages"
          :tableSize="4"
          @paginationChange="paginationChange"
        />
        
      </div>
    </template>
  </card>
</template>
<script>
import { StatsCard, ChartCard } from "@/components/dashboard/index";
import RFMTrackingMessagesSection from "@/components/dashboard/sections/RFMTrackingMessagesSection.vue";
import PaginationFunctional from "@/components/PaginationFunctional.vue";
export default {
  name: "RFMTrackingContainerSection",
  props: {
    rfmTrackingMessages: Array,
  },
  components: {
    StatsCard,
    ChartCard,
    RFMTrackingMessagesSection,
    PaginationFunctional,
  },
  data() {
    return {
      rfmTrackingMessagesSubList: null,
    };
  },
};
</script>
<style scoped>
.aling-between {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  align-content: center;
}
.text-grey {
  color: #a49e93 !important;
}
.p-10 {
  padding: 10px;
}
</style>
